import React from 'react';
import { connect } from 'react-redux';
import TopNav from 'Containers/TopNav';
import TakeOrder from './order/take';

function MainApp({ containerClassnames, ...routeProps }) {
    return (
        <div id="app-container" className={containerClassnames}>
            <TopNav />
            <main>
                <div className="container-fluid">
                    <div className="dashboard-wrapper">
                        <TakeOrder {...routeProps} />
                    </div>
                </div>
            </main>
        </div>
    );
}

export default connect(({ menu }) => ({
    containerClassnames: menu.containerClassnames,
}))(MainApp);
